import { createTheme } from "@mui/material/styles";
import { fontFamily, gx } from "./tokens";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: gx.teal,
      contrastText: "#F8FAFC",
    },
    secondary: {
      main: gx.red,
      contrastText: "#F8FAFC",
    },
    error: {
      main: gx.red,
    },
    warning: {
      main: gx.orange,
    },
    background: {
      default: gx.canvas,
      paper: gx.surface,
    },
    text: {
      primary: gx.ink,
      secondary: gx.inkSoft,
    },
    divider: gx.border,
  },
  typography: {
    fontFamily,
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: gx.radius.control,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily,
          backgroundColor: gx.canvas,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: gx.radius.control,
          minHeight: 40,
          paddingInline: 16,
        },
        containedPrimary: {
          backgroundColor: gx.red,
          color: "#F8FAFC",
          "&:hover": {
            backgroundColor: "#B8141B",
          },
          "&.Mui-disabled": {
            color: "#F8FAFC",
            opacity: 0.55,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "10px 12px",
          textAlign: "center",
          color: gx.ink,
          borderColor: gx.border,
          fontFamily,
        },
        head: {
          backgroundColor: gx.teal,
          color: "#F8FAFC",
          fontWeight: 600,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: gx.surface,
          "&:hover": {
            backgroundColor: "#EEF3F6",
          },
        },
        head: {
          backgroundColor: gx.teal,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          color: gx.inkSoft,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: gx.radius.surface,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: gx.radius.control,
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: gx.teal,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: gx.teal,
            borderWidth: 2,
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: gx.navy,
          color: "#F8FAFC",
          fontWeight: 600,
          fontSize: "0.8125rem",
          borderRadius: gx.radius.control,
        },
        arrow: {
          color: gx.navy,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: gx.red,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          "&.Mui-selected": {
            color: gx.red,
          },
        },
      },
    },
  },
});

export default muiTheme;
